import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckboxChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M0 4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.636 4.364a.9.9 0 0 1 0 1.272l-5.23 5.23a1.293 1.293 0 0 1-1.802.025L3.238 8.654a.9.9 0 0 1 1.237-1.308l2.008 1.899 4.88-4.881a.9.9 0 0 1 1.273 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckboxChecked;
